import axios from "axios";
import Attachments from "@/services/AttachmentService";
import { makeAttachmentLoadError } from "@/screen/Identities/Interfaces/IdentityFormInterfaces";
import type { ResolvedAttachment } from "@/screen/Identities/Interfaces/IdentityFormInterfaces";

/** Extrae el nombre de archivo de una URL o ruta. Si ya es solo un nombre, lo devuelve tal cual. **/
function extractFileName(filenameOrUrl: string): string
{
    try
    {
        return new URL(filenameOrUrl).pathname.split("/").pop() || filenameOrUrl;
    }
    catch
    {
        return filenameOrUrl.split("/").pop() || filenameOrUrl;
    }
}

/** Descarga un adjunto remoto y lo resuelve exactamente una vez. El caller es responsable de revocar `objectUrl` cuando ya no lo necesite. **/
export async function loadAttachment(filenameOrUrl: string): Promise<ResolvedAttachment>
{
    const fileName = extractFileName(filenameOrUrl);

    try
    {
        const response = await Attachments.getBlobAttachment(fileName);
        const mimeType: string = response.headers["content-type"] || "application/octet-stream";
        const blob = new Blob([response.data], { type: mimeType });
        const objectUrl = URL.createObjectURL(blob);
        return { blob, objectUrl, mimeType, fileName };
    }
    catch(err: unknown)
    {
        const httpStatus = axios.isAxiosError(err) ? (err.response?.status ?? null) : null;
        throw makeAttachmentLoadError(fileName, httpStatus);
    }
}

/** Convierte un ResolvedAttachment en un File (p. ej. para enviarlo a un servicio de análisis). **/
export function resolvedAttachmentToFile(resolved: ResolvedAttachment): File
{
    return new File([resolved.blob], resolved.fileName, { type: resolved.mimeType });
}